"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPayloadAction = exports.createAction = exports.createActionTypes = exports.createAsyncActionTypes = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var NAMESPACE_PREFIX = "@@";

var addActionSuffix = function addActionSuffix(name, suffix) {
  return "".concat(name, "/").concat(suffix);
};
/**
 * @param {String} name - action name
 * @typedef {Object} RequestActionTypes
 * @property {String} REQUEST - Indicates the start of async requesting.
 * @property {String} SUCCESS - Indicates success of executed request.
 * @property {String} FAILURE - Indicates failure of executed request.
 * @returns {RequestActionTypes}
 */


var createAsyncActionTypes = function createAsyncActionTypes(name) {
  return {
    REQUEST: addActionSuffix(name, "REQUEST"),
    SUCCESS: addActionSuffix(name, "SUCCESS"),
    FAILURE: addActionSuffix(name, "FAILURE")
  };
};
/**
 * This is helper method which allows you create action types with specific prefix that looks like @@{namespace}/action
 * @param {Object} definitions - simple pair
 * @param {String} namespace - prefix of action
 * @returns {String | RequestActionTypes} - formatted response
 */


exports.createAsyncActionTypes = createAsyncActionTypes;

var createActionTypes = function createActionTypes(namespace, definitions) {
  var actionTypes = {};

  for (var _key in definitions) {
    var definition = definitions[_key];

    if (typeof definition === "string") {
      actionTypes[_key] = "".concat(NAMESPACE_PREFIX).concat(namespace, "/").concat(definition);
    } else if (_typeof(definition) === "object") {
      actionTypes[_key] = createActionTypes(namespace, definition);
    }
  } // force cast throw any


  return actionTypes;
};
/**
 * Helper function that define universal signature of action object
 * @param type
 * @returns {{type: *}}
 */


exports.createActionTypes = createActionTypes;

var createAction = function createAction(type) {
  return {
    type: type
  };
};

exports.createAction = createAction;

var createPayloadAction = function createPayloadAction(type, payload) {
  return {
    type: type,
    payload: payload
  };
};

exports.createPayloadAction = createPayloadAction;